import { getCSSVariableValue } from "../../../../_metronic/assets/ts/_utils";
import { escapeODataString } from "../../../axios/odata";

export interface DocumentFilterValues {
    search: string;
    channel: string[];
    type: string[];
    status: string[];
    experience: string;
    dateRange: {
        startDate: Date | null,
        endDate: Date | null
    };
    page: number;
    perPage: number;
    totalRows: number;
    loading: boolean;
    sortState: {
        field: string;
        direction: string;
    }
}


export const buildDocumentsFilterQuery = (filterValues: DocumentFilterValues, includeStatus: boolean) => {
    const filter = [];

    if (filterValues.search) {
        const search = escapeODataString(filterValues.search);
        filter.push(`(contains(Number, '${search}') or contains(Channel, '${search}') or contains(LinkedOrderNumber, '${search}') or contains(Type, '${search}') or contains(Status, '${search}') or contains(ClientReference, '${search}'))`);
    }

    if (filterValues.channel && filterValues.channel.length > 0) {
        const parts = filterValues.channel.map((c) => `Channel eq '${escapeODataString(c)}'`);
        filter.push(`(${parts.join(' or ')})`);
    }

    if (filterValues.experience) {
        if (filterValues.experience === 'X-CHANNEL-EMAIL-PRINT ==> Print') {
            filter.push(`LinkedOrderChannels/$count gt 1 and Channel eq 'print'`);
        } else if (filterValues.experience === 'X-CHANNEL-EMAIL-PRINT ==> Email') {
            filter.push(`LinkedOrderChannels/$count gt 1 and Channel eq 'email'`);
        } else {
            filter.push(`LinkedOrderChannels/$count gt 1`);
        }
    }

    if (filterValues.type && filterValues.type.length > 0) {
        const parts = filterValues.type.map((t) => `Type eq '${escapeODataString(t)}'`);
        filter.push(`(${parts.join(' or ')})`);
    }

    if (filterValues.dateRange && filterValues.dateRange.startDate && filterValues.dateRange.endDate) {
        filter.push(`Created ge ${filterValues.dateRange.startDate.toISOString()} and Created le ${filterValues.dateRange.endDate.toISOString()}`);
    }

    if (includeStatus && filterValues.status && filterValues.status.length > 0) {
        const parts = filterValues.status.map((s) => `Status eq '${escapeODataString(s)}'`);
        filter.push(`(${parts.join(' or ')})`);
    }

    const filterQuery = filter.length ? filter.join(' and ') : '';
    return filterQuery;
}


interface DocumentStatusLabelColorClassName {
    status: string;
    label: string;
    color: string;
    className: string;
    classNameText: string;
}

export const DOCUMENT_STATUS_LABELS_COLORS_CLASSNAMES: DocumentStatusLabelColorClassName[] = [
    {
        status: 'created',
        label: 'Created',
        color: '#7A8599',
        className: 'document-status-badge-created',
        classNameText: 'document-status-text-created'
    },
    {
        status: 'accepted',
        label: 'Accepted',
        color: getCSSVariableValue('--bs-primary'),
        className: 'badge-primary',
        classNameText: 'text-primary'
    },
    {
        status: 'rejected',
        label: 'Rejected',
        color: getCSSVariableValue('--bs-danger'),
        className: 'badge-danger',
        classNameText: 'text-danger'
    },
    {
        status: 'acknowledged',
        label: 'Acknowledged',
        color: '#334155',
        className: 'document-status-badge-acknowledged',
        classNameText: 'document-status-text-acknowledged'
    },
    {
        status: 'sent',
        label: 'Sent',
        color: getCSSVariableValue('--bs-success'),
        className: 'badge-success',
        classNameText: 'text-success'
    },
    {
        status: 'printing',
        label: 'Printing',
        color: getCSSVariableValue('--bs-info'),
        className: 'badge-info',
        classNameText: 'text-info'
    },
    {
        status: 'tracked',
        label: 'Tracked',
        color: getCSSVariableValue('--bs-primary-success'),
        className: 'badge-light-success',
        classNameText: 'text-light-success'
    },
    {
        status: 'delivered',
        label: 'Delivered',
        color: getCSSVariableValue('--bs-success'),
        className: 'badge-success',
        classNameText: 'text-success'
    },
    {
        status: 'notdelivered',
        label: 'Not Delivered',
        color: getCSSVariableValue('--bs-secondary'),
        className: 'badge-secondary',
        classNameText: 'text-secondary'
    },
    {
        status: 'bounced',
        label: 'Bounced',
        color: getCSSVariableValue('--bs-warning'),
        className: 'badge-warning',
        classNameText: 'text-warning'
    },
    {
        status: 'blocked',
        label: 'Blocked',
        color: getCSSVariableValue('--bs-danger'),
        className: 'badge-danger',
        classNameText: 'text-danger'
    },
    {
        status: 'processing',
        label: 'Processing',
        color: getCSSVariableValue('--bs-info'),
        className: 'badge-info',
        classNameText: 'text-info'
    },
    {
        status: 'submitted',
        label: 'Submitted',
        color: getCSSVariableValue('--bs-info'),
        className: 'badge-info',
        classNameText: 'text-info'
    }
];

export function getDocumentStatusProps(status: string): DocumentStatusLabelColorClassName | undefined {
    const result = DOCUMENT_STATUS_LABELS_COLORS_CLASSNAMES.find(item => item.status === status);
    return result;
};
